import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

let bugsnagOptions = {
  apiKey: 'ce4301c9b1657a0fb1bdf01b80db7c44',
  appVersion: window.meta.appVersion,
  enabledReleaseStages: ['production', 'staging', 'staging2'],
  onError: (event) => { event.setUser(window.meta.userId); },
  plugions: [new BugsnagPluginReact()],
  releaseStage: window.meta.environment,
  collectUserIp: false
};

if (window.meta.environment === 'test') {
  bugsnagOptions = { ...bugsnagOptions, logger: null };
}

const bugsnagClient = Bugsnag.start(bugsnagOptions);

export default bugsnagClient;
